<div class="step-business">
  <div class="hero">
    <p class="hero__hello">Hi,</p>
    <h2 class="hero__title">Where should we start?</h2>
    <p class="hero__subtitle">
      Create social-ready posts with one prompt and optional website context.
    </p>
  </div>

  <div class="credit-limits">
    <div class="credit-limit">
      <span class="credit-limit__label">AI Image credits</span>
      <span class="credit-limit__value">{{ service.aiImageCredits() ?? 0 }}</span>
    </div>
  </div>

  <form [formGroup]="form" class="gemini-form" [attr.aria-busy]="isFetchingMetadata">
    <div class="platform-pills" aria-hidden="true">
      <span class="platform-pill platform-pill--instagram">Instagram</span>
      <span class="platform-pill platform-pill--facebook">Facebook</span>
      <span class="platform-pill platform-pill--linkedin">LinkedIn</span>
      <span class="platform-pill platform-pill--x">X</span>
    </div>

    <div class="gemini-box">
      <textarea
        id="postPrompt"
        formControlName="prompt"
        class="prompt-input"
        rows="2"
        placeholder="Ask Confe AI to create your posts..."
      ></textarea>
      <div class="prompt-footer">
        <div class="footer-left">
          <span class="footer-icon">🔗</span>
          <span class="footer-tools">Attach website for brand context</span>
        </div>
        <div class="footer-send-group">
          <button
            type="button"
            class="footer-send footer-send--main"
            [disabled]="isGenerateDisabled"
            (click)="onContinue()"
          >
            {{ isFetchingMetadata ? 'Reading website…' : selectedGenerateLabel }}
          </button>
          <button
            type="button"
            class="footer-send footer-send--toggle"
            [disabled]="isGenerateDisabled"
            (click)="toggleGenerateMenu()"
            aria-label="Choose generation type"
          >
            ▼
          </button>
          @if (isGenerateMenuOpen) {
            <div class="generate-menu">
              <button type="button" [disabled]="isGenerateDisabled" (click)="onContinue('single')">
                Generate post
              </button>
              <button type="button" [disabled]="isGenerateDisabled" (click)="onContinue('three')">
                Generate 3 posts
              </button>
              <button type="button" [disabled]="isGenerateDisabled" (click)="onContinue('weekly')">
                Generate week posts
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    @if (form.controls.prompt.invalid && form.controls.prompt.touched) {
      <p class="field-hint-inline field-hint-inline--error">Enter a short prompt to continue.</p>
    }
    @if (!service.hasAiImageCredits()) {
      <p class="field-hint-inline field-hint-inline--error">
        No AI post credits remaining. Upgrade your plan to generate posts.
      </p>
    }

    <div class="website-row">
      <label class="website-row__label" for="websiteUrl">Website URL (optional)</label>
      <div class="website-input">
        <input
          id="websiteUrl"
          type="url"
          formControlName="websiteUrl"
          class="website-input__field"
          placeholder="https://yourwebsite.com"
          (blur)="fetchWebsiteMetadata()"
        />
      </div>
      @if (isFetchingMetadata) {
        <p class="field-hint-inline">Reading website details...</p>
      }
      @if (metadataError) {
        <p class="field-hint-inline field-hint-inline--error">{{ metadataError }}</p>
      }
    </div>

    <div class="quick-prompt-wrap">
      <p class="quick-prompt-title">Try asking anything like:</p>
      <div class="quick-chips">
        @for (chip of quickPrompts; track chip.label) {
          <button type="button" class="quick-chip" (click)="applyQuickPrompt(chip.prompt)">
            <span class="quick-chip__icon">{{ chip.icon }}</span>
            <span class="quick-chip__text">{{ chip.label }}</span>
          </button>
        }
      </div>
    </div>
  </form>
</div>
